/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Needed for redux-saga es6 generator support
import "core-js/stable";
import "regenerator-runtime/runtime";

// Import all the third party stuff
import { ConnectedRouter } from "connected-react-router";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import history from "utils/history";

import "global-styles.css";
import "sanitize.css/sanitize.css";

import factory, { configureHandler } from "apiHandler";
import { sessionExpired } from "scenes/redux";

// Import root app
import App from "scenes/App";

// Import Language Provider
import LanguageProvider from "scenes/LanguageProvider";
import { GETAPIHANDLER } from "utils/getApiHandlerEffect";

import configureStore from "./configureStore";

// Import i18n messages
import { translationMessages } from "./i18n";

// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history, {
  [GETAPIHANDLER]: factory,
});

configureHandler(() => store.dispatch(sessionExpired()));

const MOUNT_NODE = document.getElementById("app");

const render = (messages) => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages}>
        <ConnectedRouter history={history}>
          <App history={history} />
        </ConnectedRouter>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE
  );
};

if (import.meta.hot) {
  import.meta.hot.accept(["./i18n", "scenes/App"], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  Promise.resolve(import("intl"))
    .then(() => Promise.all([import("intl/locale-data/jsonp/en")])) // eslint-disable-line prettier/prettier
    .then(() => render(translationMessages))
    .catch((err) => {
      throw err;
    });
} else {
  render(translationMessages);
}
